// Every Peach id is XX-YYYY-YYYY: a two-letter type prefix, then two groups of
// four letters or digits.
const PEACH_ID_PATTERN = /^[A-Z]{2}-[A-Z0-9]{4}-[A-Z0-9]{4}$/

export const isPeachId = (value: unknown): boolean =>
  typeof value === 'string' && PEACH_ID_PATTERN.test(value.trim())

// A useForm rule. Passes an empty value so it composes after
// `validators.required` rather than repeating it.
export const peachIdRule = (value: unknown): boolean | string => {
  const id = typeof value === 'string' ? value.trim() : ''
  return !id || isPeachId(id) || 'Must be in the format XX-YYYY-YYYY'
}
